import RequestAbstract from "../abstract";

export default class PublicChargebackDocuments extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-chargeback-documents';
    }

}
